import React, { SVGProps } from 'react';

export const Cross = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.62 20.88 12 13.274 4.38 20.88l-1.26-1.26L10.726 12 3.12 4.38l1.26-1.26L12 10.726l7.62-7.606 1.26 1.26L13.274 12l7.606 7.62-1.26 1.26Z"
    />
  </svg>
);
